<template>
  <div class="container-box">
    <div
      class="card-list"
      :class="{ 'fit-sidebar-tab': this.inSidebarTab }"
      v-infinite-scroll="loadMoreNews"
      infinite-scroll-disabled="isLoading"
      infinite-scroll-distance="64"
      infinite-scroll-immediate-check="false"
    >
      <div class="card-list-title">{{ getTitle }}</div>
      <StoryCard
        v-for="(story, index) in news"
        :story="story"
        :key="index"
        :isContactMode="isContactMode"
        @selectStory="selectStory"
      />
    </div>
    <v-row class="loader">
      <v-progress-linear
        v-if="isLoading"
        indeterminate
        height="4px"
        top
        fixed
      />
    </v-row>
  </div>
</template>
<script>
import infiniteScroll from 'vue-infinite-scroll';
import { contentModes } from '../../utils/mappers';
import StoryCard from './StoryCard.vue';
import { debounce } from 'lodash';

export default {
  components: {
    StoryCard,
  },
  directives: { infiniteScroll },
  data() {
    return {
      contentModes: contentModes,
    };
  },
  props: {
    news: Array,
    isLoading: Boolean,
    homeContentMode: Number,
    inSidebarTab: Boolean,
  },

  computed: {
    getTitle() {
      return this.homeContentMode ? 'Lista de Contatos' : 'Lista de Pautas';
    },

    isContactMode() {
      return this.homeContentMode === contentModes.CONTACT;
    },
  },

  methods: {
    selectStory(story) {
      this.$emit('setSelectedStory', story);
    },
    loadMoreNews: debounce(function() {
      this.$emit('loadMoreNews');
    }, 1000),
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/theme-v2.scss';
@import '@/assets/scss/fixes.scss';
@import '@/assets/scss/inputs.scss';

.card-list {
  display: grid;
  grid-column-gap: 8px;
  grid-row-gap: 8px;
  grid-template-columns: repeat(auto-fill, minmax(440px, 1fr));
  grid-auto-rows: 28px;
  width: 100%;
  min-height: 100vh;
  margin: 0;
  box-sizing: border-box;
  background-color: $color-background;
  padding: 160px 16px 40px;

  @include for-size(desktop-down) {
    // padding: 72px 16px 16px 16px;
    display: block;
  }

  &::after {
    content: '';
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 80px;
    background: linear-gradient(
      to bottom,
      rgba($color-background, 0),
      $color-background
    );
  }

  .card-list-title {
    display: none;
    flex-wrap: wrap;
    width: 100%;
    font-family: 'globotipo' !important;
    font-weight: 500 !important;
    font-size: 1.2em !important;
    font-style: italic;
    line-height: 1em;
    margin: 0 0 24px 0;
    color: $color-black-64;

    @include for-size(desktop-down) {
      display: flex;
    }
  }
}

.v-progress-linear {
  z-index: 10;
}
</style>
